import * as React from 'react';

import { cn } from '../cn';

function Input({
  className,
  type,
  icon,
  iconPosition = 'left',
  classNameWrapper,
  ...props
}: React.ComponentProps<'input'> & {
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  classNameWrapper?: string;
}) {
  return (
    <div className={cn('relative w-full', classNameWrapper)}>
      {icon && iconPosition === 'left' && (
        <div className="text-muted-foreground absolute top-1/2 left-3 -translate-y-1/2">
          {icon}
        </div>
      )}
      <input
        placeholder={props.placeholder}
        type={type}
        data-slot="input"
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-input-selection dark:bg-input/30 border-input disabled:bg-surface-disabled flex h-9 w-full min-w-0 rounded-2xl border bg-transparent px-3 py-6 text-base shadow-none transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-sm placeholder:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-[#0000005C] disabled:opacity-60 disabled:placeholder:text-[#0000005C] md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          'border-alias-outline border-[1px]',
          icon && iconPosition === 'left' && 'pl-10',
          icon && iconPosition === 'right' && 'pr-10',
          className
        )}
        {...props}
      />
      {icon && iconPosition === 'right' && (
        <div className="text-muted-foreground absolute top-1/2 right-3 -translate-y-1/2">
          {icon}
        </div>
      )}
    </div>
  );
}

export { Input };
